import styled from 'styled-components';
import WhiteTickSvg from '../../assets/mytrips/tick-white.svg';

const WhiteTickIcon = styled(WhiteTickSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.3rem'};
  height: ${props => props.height || '1rem'};
  margin: ${props => props.margin};
`;

export default WhiteTickIcon;
